import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvisosService } from '../../services/avisos.service';

/**
 * Los avisos flotantes, arriba a la derecha.
 *
 * Va en el shell de la app y no en cada pantalla: un aviso es de la aplicación,
 * y montarlo por pantalla haría que se pierda justo al navegar, que es cuando
 * más falta hace.
 *
 * Vive **debajo de la cabecera** (54px) para no tapar la campana ni el menú de
 * usuario, que son lo primero que alguien va a querer tocar.
 */
@Component({
  selector: 'app-avisos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avisos.component.html',
  styleUrl: './avisos.component.css'
})
export class AvisosComponent {
  private readonly servicio = inject(AvisosService);

  readonly avisos = this.servicio.avisos;

  /* Pasar el mouse por encima frena la cuenta: que un aviso se borre mientras
     uno lo lee es la peor forma de enterarse de algo. */
  frenar(id: number): void {
    this.servicio.frenar(id);
  }

  reanudar(id: number): void {
    this.servicio.reanudar(id);
  }

  cerrar(id: number): void {
    this.servicio.cerrar(id);
  }
}
